import { formatDate } from "@/utils/helpers/date-time/datetime-format";

export const getStartsAtTitle = (startDate?: string) =>
  `Starts on ${formatDate(startDate ?? "", { format: "MMM D, YYYY" })}`;
